import Intro from "../../components/intro/Intro";
import Clickard from "../../components/Clickard/Clickard";

const Home = () => {
  return (
    <>
      <Intro
        primary="JAKE MORENO"
        secondary="If you want to learn about art, cooking, finances, photography, software engineering, video games, web development, and other things I love..."
        tertiary="You're in the right place."
      />
      <div className="column p01 g1">
        <h2>HOBBIES</h2>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/cherry_blossom_stroll.jpg",
              alt: "A female Animal Crossing villager with black hair, tan skin, and gray-blue eyes strolling (leftward) through a grove of cherry blossom trees. She's wearing a pink kimono and brown sandals, is holding a basket of cherry blossom petals, and is looking at the camera while smiling.",
            }}
            link="/animal-crossing"
            text="Animal Crossing"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/art/egg2x1.png",
              alt: "A white egg on a perfectly-white backdrop. Hopefully, it looks decently realistic (aside from a few shading mistakes that I won't fix), but it was drawn using Procreate.",
            }}
            link="/art"
            text="Art"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/lifestyle/feet2x1.png",
              alt: "Squilbert",
            }}
            link="/photography"
            text="Photography"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/logo/ss2x1.jpg",
              alt: "SquidSlippers",
            }}
            link="/software-engineering"
            text="Software Engineering"
          />
        </div>

        <h2>RESOURCES</h2>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/money-bender-media/logos/600x300.jpg",
              alt: "The Bendy Budget logo: A white symbol that somewhat resembles the letter 'm' (lowercase) rotated clockwise 45 degrees against a bold orange background. (The 'm' is missing its tail in the top left, and the middle pillar is elongated.)",
            }}
            isExternal
            link="https://bendybudget.com/"
            text="Bendy Budget"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/logo/ccc2x1.jpg",
              alt: "The Crystal Clear Consulting logo: A purple obelisk-shaked crystal (with five sides) rotated counter-clockwise 90° (so it's pointing left) against a light lavender background. The crystal uses three shades of purple.",
            }}
            isExternal
            link="https://crystal-clear-consulting.com/"
            text="Crystal Clear Consulting"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/banana_bread/loaf_2x1.jpg",
              alt: "An uncut loaf of banana bread on a gray countertop, shot from directly above. It is cooked to perfection (if I may say so myself.)",
            }}
            link="/cookbook"
            text="Interactive Cookbook"
          />
          <Clickard
            img={{
              src: require("./queues.png"),
              alt: "An uncut loaf of banana bread on a gray countertop, shot from directly above. It is cooked to perfection (if I may say so myself.)",
            }}
            link="/software-engineering/queues"
            text="Interactive Queue Tutorial"
          />
        </div>
      </div>
    </>
  );
};

export default Home;
